import { composeIO } from 'react-compose-io'
import { appMenuIO } from './AppMenu.IO'
import { AppMenuView } from './AppMenu.View'

export const AppMenu = composeIO(AppMenuView, appMenuIO)
